import CartBrowser from 'components/admin/Carts/CartBrowser.jsx'
import DealerCartDetails from 'components/admin/Carts/DealerCart/DealerCartDetails.jsx'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { cancelConfirm } from 'redux/navigation'
import { loadDealerOrders } from 'redux/carts'
import { loadUsers } from 'redux/userAdmin'
import { Grid } from 'semantic-ui-react'

const mapStateToProps = undefined

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      cancelConfirm,
      loadDealerOrders,
      loadUsers,
    },
    dispatch
  )
}

class DealerOrders extends React.Component {
  componentWillMount() {
    const { loadDealerOrders, loadUsers } = this.props
    loadDealerOrders(true)
    loadUsers()
  }

  render() {
    return (
      <Grid columns={2}>
        <Grid.Row>
          <Grid.Column
            mobile={12}
            tablet={12}
            computer={12}
            largeScreen={4}
            widescreen={4}
            className="stacked top up-to-computer">
            <CartBrowser kind="dealer_orders" />
          </Grid.Column>
          <Grid.Column
            mobile={12}
            tablet={12}
            computer={12}
            largeScreen={8}
            widescreen={8}>
            <DealerCartDetails />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

DealerOrders = connect(mapStateToProps, mapDispatchToProps)(DealerOrders)
export default DealerOrders



// WEBPACK FOOTER //
// ./src/containers/admin/dealer_orders.jsx